export const createVariousDocumentAdminService = (fetch) => async (document) => {
  try {
    const response = await fetch({ url: '/api/v1/documentos-admin-varios', method: 'post', body: document })
    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
